"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TERMS_PAGE = exports.HOME_PATH = void 0;
exports.getHrefSrc = getHrefSrc;
exports.getImgSrc = getImgSrc;
exports.getPredefinedPageName = getPredefinedPageName;
exports.highlightSyntax = highlightSyntax;
exports.markdownToHTML = markdownToHTML;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _url = require("url");
var _exchangeMarkdownParser = _interopRequireDefault(require("@mulesoft/exchange-markdown-parser"));
var _prismCore = _interopRequireDefault(require("prismjs/components/prism-core"));
require("prismjs/components/prism-dataweave");
require("prismjs/components/prism-clike");
require("prismjs/components/prism-markup");
require("prismjs/components/prism-javascript");
require("prismjs/components/prism-java");
require("prismjs/components/prism-markup-templating");
require("prismjs/components/prism-php");
require("prismjs/components/prism-python");
require("prismjs/components/prism-json");
require("prismjs/components/prism-yaml");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TERMS_PAGE = exports.TERMS_PAGE = '.terms';
var HOME_PATH = exports.HOME_PATH = 'home';
function getPredefinedPageName(path) {
  if (TERMS_PAGE === path) {
    return 'Terms and conditions';
  }
  var parsedPath = path.split('/');
  if (parsedPath.length === 1) {
    return path;
  }
  return parsedPath[1];
}
function highlightSyntax(code, language) {
  var prismLang = _prismCore.default.languages[language];
  if (!prismLang) {
    return code;
  }
  return _prismCore.default.highlight(code, prismLang);
}
function getResourceURI(params) {
  var groupId = params.groupId,
    assetId = params.assetId,
    isDraft = params.isDraft,
    config = params.config;
  var externalURI = config.externalURI;
  var imgURI = (0, _url.format)(externalURI);
  var draftPath = isDraft ? 'draft/' : '';
  if ('version' in params) {
    return "".concat(imgURI, "/").concat(groupId, "/").concat(assetId, "/").concat(params.version, "/").concat(draftPath);
  }
  return "".concat(imgURI, "/").concat(groupId, "/").concat(assetId, "/minor/").concat(params.minorVersion, "/").concat(draftPath);
}
function getImgSrc(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    _ref$isDraft = _ref.isDraft,
    isDraft = _ref$isDraft === void 0 ? false : _ref$isDraft,
    config = _ref.config;
  var imgURI = getResourceURI({
    config: config,
    groupId: groupId,
    assetId: assetId,
    version: version,
    isDraft: isDraft
  });
  return function (src) {
    if (src.startsWith('resources/')) {
      return "".concat(imgURI).concat(src);
    }
    return src;
  };
}
function getHrefSrc(_ref2) {
  var groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    version = _ref2.version,
    _ref2$isDraft = _ref2.isDraft,
    isDraft = _ref2$isDraft === void 0 ? false : _ref2$isDraft,
    config = _ref2.config;
  var _version$split = version.split('.'),
    _version$split2 = (0, _slicedToArray2.default)(_version$split, 2),
    major = _version$split2[0],
    minor = _version$split2[1];
  var minorVersion = "".concat(major, ".").concat(minor);
  var hrefURI = getResourceURI({
    config: config,
    groupId: groupId,
    assetId: assetId,
    minorVersion: minorVersion,
    isDraft: isDraft
  });
  return function (src) {
    if (src.startsWith('pages/')) {
      if (src.includes('?')) {
        var srcWithoutQuery = src.substring(0, src.indexOf('?'));
        return "".concat(hrefURI).concat(srcWithoutQuery, "/");
      }
      return "".concat(hrefURI).concat(src, "/");
    }
    return src;
  };
}
function markdownToHTML(params) {
  var imgSrc;
  var hrefSrc;
  if ('groupId' in params) {
    var config = params.config,
      groupId = params.groupId,
      assetId = params.assetId,
      version = params.version,
      _params$isDraft = params.isDraft,
      isDraft = _params$isDraft === void 0 ? false : _params$isDraft;
    imgSrc = getImgSrc({
      config: config,
      groupId: groupId,
      assetId: assetId,
      version: version,
      isDraft: isDraft
    });
    hrefSrc = getHrefSrc({
      config: config,
      groupId: groupId,
      assetId: assetId,
      version: version,
      isDraft: isDraft
    });
  }
  return (0, _exchangeMarkdownParser.default)(params.markdown, _objectSpread({
    imgSrc: imgSrc,
    hrefSrc: hrefSrc,
    minHeaderLevel: 2,
    escapeNotebooks: true
  }, params.options));
}
//# sourceMappingURL=utils.js.map